/**
 * Counts key-down edges for one key, immune to Phaser 3.90's keyboard-queue replay.
 *
 * Phaser re-dispatches its whole keyboard queue on every DOM key event and only clears it once
 * per game step, so when two keys land in one frame the earlier key's keydown (the very same DOM
 * event object) is delivered to its Key again — `key.on('down')` fires twice. `JustDown` polling
 * is not the answer either: `Key.onUp` clears the just-down flag, so a tap whose keyup lands in
 * the same frame as its keydown is lost. Counting distinct event objects fixes both: a replayed
 * event is the same object and is ignored; a same-frame tap still counts.
 *
 * Pure TypeScript (no Phaser import) so the rule is unit-tested.
 */
export class EdgeCounter {
  private last: object | null = null;
  private count = 0;

  /** Record one delivered key-down event (a replay of the last event is ignored). */
  record(event: object): void {
    if (event === this.last) return;
    this.last = event;
    this.count += 1;
  }

  /** Number of presses since the previous consume (call once per frame). */
  consume(): number {
    const n = this.count;
    this.count = 0;
    return n;
  }

  reset(): void {
    this.last = null;
    this.count = 0;
  }
}
